import React  from "react";
import ClientReferralList from "./components/ClientReferralList";
import SummaryHeader from "components/header/SummaryHeader";
import { Handshake } from "lucide-react";

const ClientReferral = () => {
	
	return (
		<div className="space-y-6">
			<SummaryHeader
				title="Client Referrals"
				icon={Handshake}
				description="View referred Clients"
				color={"teal"}
			/>
			<ClientReferralList/>
	    </div>
    );
};
export default ClientReferral;

